export default [
    {
        "id": "302456",
        "bpId": 277,
        "clientNumber": "800342",
        "amount": 22000.0,
        "compensationType": "ASLRY",
        "payFrequency": "MLY",
        "source": "userEntered",
        "tracPlanNumber": null,
        "userEntered": true,
        "sponsorProvidedPayFreq": false
    }
]
